module.exports = __webpack_public_path__ + "static/img/img_07.7748e03c.png";